const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": " \\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.8,237.2H42.9c-9,0-16.4-7.2-16.4-16.1V34.9c0-8.9,7.4-16.1,16.4-16.1h95.7v64.9h59.2v9.7c8.7,1.8,13.7,2.6,19.2,7.8l-.5-30.1L152.1.4H42.9C23.5.4,7.8,15.9,7.8,34.9v186.3c0,19,15.8,34.4,35.1,34.4l96.9-.2c-19.8-5.8-27-18.1-27-18.1h0ZM157.3,33.6l28.9,31.7h-28.9v-31.7Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,101.1c0-5.3-4-9.6-9-9.6H44.6c-4.9,0-9,4.3-9,9.6s4,9.6,9,9.6h83c4.9,0,9-4.3,9-9.6Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,145.7c0-5.3-2.4-9.6-5.4-9.6h-49.8c-3,0-5.4,4.3-5.4,9.6s2.4,9.6,5.4,9.6h49.8c3,0,5.4-4.3,5.4-9.6Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,184.9c-2.4,0-4.4,4.3-4.4,9.6s1.9,9.6,4.4,9.6h40.3c2.4,0,4.4-4.3,4.4-9.6s-1.9-9.6-4.4-9.6c0,0-40.3,0-40.3,0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M223.4,155.3h-91c-1.7,0-3,1.9-3,4.4v30.5c0,2.4,1.3,4.4,3,4.4h91c1.7,0,3-1.9,3-4.4v-30.5c0-2.4-1.3-4.4-3-4.4Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,99.7c-43.2,0-78.1,35-78.1,78.1s35,78.1,78.1,78.1,78.1-35,78.1-78.1-35-78.1-78.1-78.1ZM177.9,234.8c-31.4,0-56.9-25.5-56.9-56.9s25.5-56.9,56.9-56.9,56.9,25.5,56.9,56.9-25.5,56.9-56.9,56.9h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDelete);
export default __webpack_public_path__ + "static/media/file-delete.7f2c2e0085ec00675c32e954122da52c.svg";
export { ForwardRef as ReactComponent };